module.exports = __webpack_public_path__ + "ff9353b49a0f9ccbd7518f105c9fa9b1.pdf";